import { WHATSAPP_URL } from '../../constants/whatsapp';

export default function FloatingWhatsApp() {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2">
      <div className="bg-white text-navy text-xs font-semibold px-3 py-1.5 rounded-full shadow-md animate-pulse">
        💬 Get Wholesale Price
      </div>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 flex items-center justify-center bg-whatsapp rounded-full shadow-xl wa-pulse cursor-pointer hover:scale-110 transition-transform"
        aria-label="WhatsApp omandisposables.com"
        title="WhatsApp omandisposables.com"
      >
        <i className="ri-whatsapp-line text-white text-2xl" />
      </a>
    </div>
  );
}
